<template>
  <el-form>
    <ik-form-popup-select v-model="result" name="neirong" code="name" url="health/content/content/infotype" />
    <el-form-item>
      <el-button @click="submit">提交</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  data() {
    return {
      labels: [
        {
          "conInd": 1,
          "code": "l-07",
          "entryPerson": "VisitorUser",
          "modifyTimeStamp": 1740018406000,
          "modifyPerson": "VisitorUser",
          "rs2": null,
          "rs1": null,
          "rs4": null,
          "entryTime": "2025-02-20 10:08:02",
          "rs3": null,
          "modifyTime": "2025-02-20 10:26:46",
          "rs6": null,
          "rs5": null,
          "rs10": null,
          "demInd": 1,
          "rs8": null,
          "entryTimeStamp": 1740017282000,
          "rs7": null,
          "name": "中药信息",
          "rs9": null,
          "id": 6,
          "remarks": null
        },
        {
          "conInd": 1,
          "code": "l-01",
          "entryPerson": "VisitorUser",
          "modifyTimeStamp": 1740017153000,
          "modifyPerson": "VisitorUser",
          "rs2": null,
          "rs1": null,
          "rs4": null,
          "entryTime": "2025-01-13 10:40:30",
          "rs3": null,
          "modifyTime": "2025-02-20 10:05:53",
          "rs6": null,
          "rs5": null,
          "rs10": null,
          "demInd": 1,
          "rs8": null,
          "entryTimeStamp": 1736736030000,
          "rs7": null,
          "name": "咨询",
          "rs9": null,
          "id": 2,
          "remarks": null
        }
      ],
      result: ""
    }
  },
  methods: {
    submit() {
    }
  }
}
</script>
